import { Navigate } from 'react-router-dom';

import { IS_SERVICES } from '@/app/app-variant';
import { WELCOME_PATH } from '@/app/home-path';

/**
 * Index `/` route. On the CRM everyone lands on the Welcome Utazzer page - the
 * single default view across all roles. On the Services (accounts) app there is
 * no Welcome page, so it lands on Invoices.
 */
export const HomeRoute = (): React.JSX.Element => (
  <Navigate to={IS_SERVICES ? '/invoices' : WELCOME_PATH} replace />
);
